module.exports = __webpack_public_path__ + "img/fondo-login.63ecfd9c.png";